import { useState, useEffect } from 'react'
import { getCommon } from '../../../redux/slices/flight'
import { useDispatch, useSelector } from 'react-redux'

import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormControl from '@mui/material/FormControl'
import FormLabel from '@mui/material/FormLabel'

import { createTheme, ThemeProvider } from '@mui/material/styles'

import { useSearchParams } from 'next/navigation'

const customTheme = createTheme({
  components: {
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: '#ffffff', // Custom color for CircularProgress
          width: '20px !important',
          height: '20px !important'
        }
      }
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: '#6DC8BF', // Default radio color
          '&.Mui-checked': {
            color: '#6DC8BF' // Checked radio color (Custom)
          }
        }
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          fontSize: '14px', // Adjust label font size
          fontWeight: 'bold', // Make label bold
          color: '#333' // Change text color
        }
      }
    }
  }
})

const FromTo = props => {
  const dispatch = useDispatch()
  const searchParams = useSearchParams()
  const [searchValue, setSearchValue] = useState('OneWay')
  const [selectedItem, setSelectedItem] = useState(null)
  const { commonRes } = useSelector(state => state.flight)

  useEffect(() => {
    dispatch(getCommon())
  }, [dispatch])

  const locationSearchContent = [
    {
      id: 1,
      name: 'One Way Trip',
      address: 'One Way Trip'
    },
    {
      id: 2,
      name: 'Round-Trip',
      address: 'Round-Trip'
    }
    // {
    //   id: 3,
    //   name: "Multi City",
    //   address: "Multi City",
    // },
  ]

  const handleOptionClick = item => {
    setSearchValue(item.name)
    setSelectedItem(item)
    props.setFilter({ ...props.filter, ['way']: item.id })
  }

  const handleOptionChange = item => {
    const { value } = item.target
    setSearchValue(value)
  }

  useEffect(() => {
    const wayParam = searchParams.get('way') // Get 'way' param from URL
    if (commonRes) {
      if (wayParam) {
        const wayId = parseInt(wayParam, 10) // Convert to integer

        // Find matching journey type
        const matchedJourney = commonRes.journeyType.find(
          journey => journey.id === wayId
        )

        // Update state with the journeyType name
        if (matchedJourney) {
          setSearchValue(matchedJourney.name)
        }
      } else {
        // Find matching journey type
        const matchedJourney = commonRes?.journeyType.find(
          journey => journey.id === 1
        )

        console.log('matchedJourney', matchedJourney)

        // Update state with the journeyType name
        if (matchedJourney) {
          setSearchValue(matchedJourney.name)
        }
      }
    }
  }, [searchParams])

  return (
    <>
      {/* <div className="searchMenu-loc lg:px-0 js-form-dd js-liverSearch">
        <div
          data-bs-toggle="dropdown"
          data-bs-auto-close="true"
          data-bs-offset="0,22"
        >
          <div className="text-15 text-light-1 ls-2 lh-16">
            <div className="d-flex items-center">
              <h6>{commonRes?.journeyType ? commonRes?.journeyType.find((obj) => obj.id === props.filter.way)?.name : "OneWay"}</h6>
              <img
                src="/img/filtericons/arrow.svg"
                alt="quote"
                width="20"
                className="mr-10"
              />
            </div>
          </div>
        </div>
      
        <div className="shadow-2 dropdown-menu w-100">
          <div className="bg-white px-20 py-20 js-liverSearch sm:px-0 sm:py-15 rounded-4">
            <ul className="y-gap-5 js-results">
              {commonRes && commonRes?.journeyType.map((item) => (
                <li
                  className={`-link d-block col-12 text-left rounded-4 px-20 py-15 js-search-option mb-1 ${props.filter?.way === item.name ? "active" : ""
                    }`}
                  key={item.id}
                  role="button"
                  onClick={() => handleOptionClick(item)}
                >
                  <div className="d-flex">
                   
                    <div className="ml-10">
                      <div className="text-15 lh-12 fw-500 js-search-option-target">
                        {item.name}
                      </div>
                      
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div> */}
      <ThemeProvider theme={customTheme}>
        <FormControl sx={{
          justifyContent: {xs: 'center', md: ''}
        }}>
          <RadioGroup
            aria-labelledby='demo-controlled-radio-buttons-group'
            name='controlled-radio-buttons-group'
            row
            value={searchValue}
            onChange={handleOptionChange}
            sx={{
              justifyContent: {xs: 'center', md: 'start'}
            }}
          >
            {commonRes &&
              commonRes?.journeyType.map(item => (
                <FormControlLabel
                  value={item?.name}
                  control={<Radio />}
                  label={item.name}
                  key={item?.id}
                  onClick={() => handleOptionClick(item)}
                />
              ))}
          </RadioGroup>
        </FormControl>
      </ThemeProvider>
    </>
  )
}

export default FromTo
